import Field from "src/component/field"
import SearchWrapper from "src/component/searchSection"
import AddMedicalService from "./AddMedicialService/AddMedicalService"
import AddMedicine from "./AddMedicine/AddMedicine"
import MedicalNotes from "./MedicalNotes/MedicalNotes"
import { useContext, useEffect, useMemo, useState } from "react"
import { useSearchParams } from "react-router-dom"
import { Context } from "src/context"
import { useTranslation } from "react-i18next"
import "./style.css"
import TabSwitch from "src/component/TabSwitch"
import MedicalFiles from "./MedicalFiles"
import { CONTROLLER_NAMES } from "src/common/constants"

const Tabs = {
    AddMedicalService: 1,
    AddMedicine: 2,
    MedicalNotes: 3,
    MedicalFiles: 4,

}

const TapsList: any[] = [
    { label: "add-medical-service", accessId: CONTROLLER_NAMES?.MobPatientMedicalServices, value: Tabs.AddMedicalService },
    { label: "add-medicine", accessId: CONTROLLER_NAMES?.PatientMedicines, value: Tabs.AddMedicine },
    { label: "medical-notes", accessId: CONTROLLER_NAMES?.MobDiagnosRequests, value: Tabs.MedicalNotes },
    { label: "medical-files", accessId: CONTROLLER_NAMES?.MobDiagnosRequests, value: Tabs.MedicalFiles },


]

const DoctorOrder = () => {

    const { t } = useTranslation()

    const [activeTab, setActiveTab] = useState(2)
    const { customSearchData, setCustomSearchData, authorizedPages } = useContext(Context)

    const [searchData, setSearchData] = useState<any>({})


    const handleChange = (key: string, value: string) => {
        setCustomSearchData((prev: any) => ({ ...prev, [key]: value }))
        setSearchData((prev: any) => ({ ...prev, [key]: value }))
    }

    const AccessedIdes = useMemo(() => authorizedPages?.map(ap => ap.id) || [], [authorizedPages])

    const screenTabs = useMemo(() => TapsList.filter(t => AccessedIdes.includes(t.accessId)), [AccessedIdes])

    useEffect(() => {
        setCustomSearchData((prev: any) => ({ ...searchData }))
    }, [activeTab])



    return (
        <>
            <div className="screen-doctor-header">
                <SearchWrapper onlyCustom haveCustomPriority >
                    <div className="alert">
                        {t('please-search')}
                    </div>
                    <div className="row">
                        {
                            //@ts-ignore
                            <Field className="col-lg-3 col-md-6 col-sm-12" label="textKeyword" placeholder={"textKeyword"} value={customSearchData?.textKeyword} setValue={(value) => handleChange("textKeyword", value)} />
                        }
                        {
                            //@ts-ignore
                            <Field className="col-lg-3 col-md-6 col-sm-12" label="keyword" placeholder={"keyword"} value={customSearchData?.keyword} setValue={(value) => handleChange("keyword", value)} />
                        }
                    </div>

                </SearchWrapper>
                <TabSwitch Tabs={screenTabs} defaultSelect={2} setTab={setActiveTab} />
            </div>

            {activeTab == Tabs.AddMedicalService ? <AddMedicalService /> : ""}
            {activeTab == Tabs.AddMedicine ? <AddMedicine /> : ""}
            {activeTab == Tabs.MedicalNotes ? <MedicalNotes /> : ""}
            {activeTab == Tabs.MedicalFiles ? <MedicalFiles /> : ""}

            {!activeTab ?
                <div className="click-to-show alert">
                    {t('select-tab')}
                </div> : ""
            }
        </>
    )
}

export default DoctorOrder